<template lang="pug">
.admin-user-table
  v-toolbar(
    dark
    color="indigo"
    flat)
    v-toolbar-title 會員列表  
  v-container(fluid)
    v-dialog(v-model="report.dialog"
      :persistent="fetching")
      template(v-slot:activator="{ on }")
        v-btn(color="info" outline v-on="on") 輸出報表
      v-card
        v-card-title 輸出會員報表
        v-card-text
          v-menu(ref="startMenu"
            v-model="startMenu"
            :close-on-content-click="false"
            min-width="290px")
            template(v-slot:activator="{ on }")
              v-text-field(v-model="report.form.start" label="會員加入日-始" outline v-on="on")
            v-date-picker(ref="startPicker"
              v-model="report.form.start"
              :min="min"
              :max="max"
              @change="saveStart")
          v-menu(ref="endMenu"
            v-model="endMenu"
            :close-on-content-click="false"
            min-width="290px")
            template(v-slot:activator="{ on }")
              v-text-field(v-model="report.form.end" label="會員加入日-終" outline v-on="on")
            v-date-picker(ref="endPicker"
              v-model="report.form.end"
              :min="min"
              :max="max"
              @change="saveEnd")
          v-combobox(v-model="report.form.range"
            :items="rangeItems"
            label="收據顯示年度"
            multiple
            outline)
        v-card-actions
          v-spacer
          v-btn(:loading="fetching" outline @click="downloadReport") 下載
          v-spacer
    v-layout
      p.headline 請選擇區域
    v-layout(wrap)
      v-flex(xs12)
        v-select(
          v-model="currentRegion"
          :items="activeRegions"
          item-value="value"
          item-text="text"
          label="區域"
          outline)
    v-layout
      v-flex(xs12)
        v-checkbox(v-model="showHide" label="顯示隱藏")
    v-layout
      v-flex
        user-table(
          :items="items"
          @update-succeed="updateTable")
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import UserTable from "@/components/tables/UserTable.vue";
import { db } from "@/firebase";
import REGIONS from "@/assets/tables/regions.json";
import errorParser from "@/utils/error";

const rangeItems = [];

for (let i = 108; i <= new Date().getFullYear() - 1911 + 2; i += 1) {
  rangeItems.push(i);
}

export default {
  name: "AdminUserTable",
  components: {
    UserTable
  },
  data() {
    return {
      regionItems: Object.entries(REGIONS).map(item => item[1]),
      currentRegion: null,
      items: [],
      report: {
        dialog: false,
        form: {
          start: null,
          end: null,
          range: []
        }
      },
      startMenu: false,
      endMenu: false,
      max: new Date().toLocaleString().replace(/\//g, "-"),
      min: "2019-01-01",
      rangeItems,
      fetching: false,
      showHide: false
    };
  },
  computed: {
    ...mapState({
      claims: state => state.auth.claims,
      regionTables: state => state.regionTable.regionTables
    }),
    activeRegions() {
      if (!this.claims) return [];

      const { role, manageRegion } = this.claims;

      if (!role) return [];

      let regions;

      switch (role) {
        case "director":
          regions = manageRegion.map(v => REGIONS[v]);
          break;

        case "north_director":
          regions = Object.entries(REGIONS).reduce((acc, item) => {
            const res = acc;
            const region = item[1];

            if (region.area === "north") {
              res.push(region);
            }

            return res;
          }, []);
          break;

        case "south_director":
          regions = Object.entries(REGIONS).reduce((acc, item) => {
            const res = acc;
            const region = item[1];

            if (region.area === "south") {
              res.push(region);
            }

            return res;
          }, []);
          break;

        default:
          regions = Object.entries(REGIONS).map(item => item[1]);
      }

      return regions;
    }
  },
  watch: {
    // set items
    async currentRegion(region) {
      if (!region) return;

      try {
        await this.updateRegionDict({ region, force: true });
        this.updateItems(region);
      } catch (e) {
        this.noDataMessage = errorParser(e);
      }
    },
    startMenu(val) {
      val && setTimeout(() => (this.$refs.startPicker.activePicker = "YEAR"));
    },
    endMenu(val) {
      val && setTimeout(() => (this.$refs.endPicker.activePicker = "YEAR"));
    },
    showHide() {
      this.updateItems(this.currentRegion);
    }
  },
  mounted() {
    this.resetRegionDictsAndTables();
  },
  methods: {
    ...mapMutations("regionTable", ["resetRegionDictsAndTables"]),
    ...mapActions("regionTable", [
      "updateRegionDict",
      "updateRegionDictItem",
      "updateTableItem"
    ]),
    updateItems(region) {
      const targetItems = this.regionTables[region];
      this.items = this.showHide
        ? targetItems
        : targetItems.filter(o => !o.hide);
    },
    async updateTable() {
      await this.updateRegionDict({ region: this.currentRegion, force: true });
      this.updateItems(this.currentRegion);
    },
    saveStart(date) {
      this.$refs.startMenu.save(date);
    },
    saveEnd(date) {
      this.$refs.endMenu.save(date);
    },
    async downloadReport() {
      this.fetching = true;

      try {
        const response = await this.$store.dispatch("api", {
          method: "get",
          url: "user-report",
          params: {
            start: this.report.form.start
              ? new Date(this.report.form.start).toJSON()
              : null,
            end: this.report.form.end
              ? new Date(this.report.form.end).toJSON()
              : null,
            range: this.report.form.range.join(",")
          }
        });

        const { data } = response;

        const link = document.createElement("a");
        const date = new Date().toLocaleDateString();
        link.download = `桃園市屏東同鄉會會員報表${date}.xlsx`;
        link.href =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          data;
        link.click();

        return (this.fetching = false);
      } catch (e) {
        return (this.fetching = false);
      }
    }
  }
};
</script>
